import axios from 'axios';
import { Service } from 'axios-middleware';

const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;

export const instance = axios.create({
  baseURL: ENDPOINT,
  headers: localStorage.getItem('user') && { authorization: JSON.parse(localStorage.getItem('user')).token },
});

// Serializa un valor para query string. Si recibe un Date, lo emite como ISO
// UTC con Z — es un fallback defensivo: los filtros de fecha deberían llegar
// ya como string ISO con offset construido en la zona del usuario (ver
// src/helpers/dates.js y el contrato del backend en
// ../mirtomex-back/__dev__/DATES_AND_TIMEZONES.md). Si aparece un Date aquí
// probablemente es un bug aguas arriba, así que lo avisamos en dev.
const serializeParamValue = (key, value) => {
  if (value instanceof Date) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(
        `[objectToParams] param "${key}" llegó como Date. Usa los helpers de src/helpers/dates.js para construir strings ISO con offset antes de enviar a la API.`,
      );
    }
    return value.toISOString();
  }
  return String(value);
};

export const objectToParams = (data = {}) =>
  Object.keys(data)
    .filter((key) =>
      data[key] !== undefined && data[key] !== null && Array.isArray(data[key]) ? data[key].length > 0 : true,
    )
    .map((key) => {
      if (Array.isArray(data[key])) {
        return `${key}=${encodeURIComponent(data[key].join(':'))}`;
      }
      return `${key}=${encodeURIComponent(serializeParamValue(key, data[key]))}`;
    })
    .join('&');

const service = new Service(instance);

service.register({
  onRequest(config) {
    return config;
  },
  onSync(promise) {
    return promise;
  },
  onResponse(response) {
    if (response.status === 406) {
      localStorage.clear();
      window.location.reload();
    }
    return response;
  },
});
